import FolderView from "../views/Calculations/FolderView.vue";
import PartView from "../views/Calculations/Parts/PartView.vue";
import VariantView from "../views/Calculations/Variants/VariantView.vue";
import ManufacturingStepView from "../views/Calculations/ManufacturingSteps/ManufacturingStepView.vue";
import MaterialView from "../views/Calculations/MaterialView.vue";
import LabourView from "../views/Calculations/LabourView.vue";
import MachineView from "../views/Calculations/Machines/MachineView.vue";
import SetupStepView from "../views/Calculations/SetupStepView.vue";
import ToolView from "../views/Calculations/ToolView.vue";
import FixtureView from "../views/Calculations/FixtureView.vue";
import LocationView from "@/views/Calculations/Location/LocationView.vue";
import ShiftModelView from "@/views/Calculations/ShiftModel/ShiftModelView.vue";
import ShiftView from "@/views/Calculations/Shift/ShiftView.vue";
import CalculationLayout from "@/layouts/CalculationLayout.vue";
import BaseDataView from "@/views/BaseData/BaseDataView.vue";
import { useSpaceStore } from "@/stores/spaceStore";
import { useAuthStore } from "@/stores/authStore";
import { useMainStore } from "@/stores/mainStore";
import MachineListView from "@/views/BaseData/DatabaseMachine/MachineListView.vue";

const calculationRoutes = [
  {
    path: "/calc/:spaceId",
    component: CalculationLayout,
    meta: { calc: true },
    children: [
      {
        path: "base-data",
        name: "base-data",
        component: BaseDataView,
        meta: { baseData: "base-data" }
      },
      {
        path: "database/machines",
        name: "database-machines",
        component: MachineListView,
        meta: { baseData: "database-machines" }
      },
      {
        path: "folder/:nodeId",
        name: "calculations-folder",
        component: FolderView
      },
      {
        path: "part/:nodeId",
        name: "calculations-part",
        component: PartView
      },
      {
        path: "variant/:nodeId",
        name: "calculations-variant",
        component: VariantView
      },
      {
        path: "manufacturing-step/:nodeId",
        name: "calculations-manufacturingStep",
        component: ManufacturingStepView
      },
      {
        path: "material/:nodeId",
        name: "calculations-material",
        component: MaterialView
      },
      {
        path: "labour/:nodeId",
        name: "calculations-labour",
        component: LabourView
      },
      {
        path: "machine/:nodeId",
        name: "calculations-machine",
        component: MachineView
      },
      {
        path: "setupStep/:nodeId",
        name: "calculations-setupStep",
        component: SetupStepView
      },
      {
        path: "tool/:nodeId",
        name: "calculations-tool",
        component: ToolView
      },
      {
        path: "fixture/:nodeId",
        name: "calculations-fixture",
        component: FixtureView
      },
      {
        path: "location/:nodeId",
        name: "calculations-location",
        component: LocationView,
        meta: { baseData: "base-data" }
      },
      {
        path: "shiftModel/:nodeId",
        name: "calculations-shiftModel",
        component: ShiftModelView,
        meta: { baseData: "base-data" }
      },
      {
        path: "shift/:nodeId",
        name: "calculations-shift",
        component: ShiftView,
        meta: { baseData: "base-data" }
      }
    ]
  }
];
export default calculationRoutes;
